<template>
  <v-sheet fluid class="pa-0 fill-height" style="overflow: hidden">
    <v-overlay :value="loaderOverlay" :absolute="true">
      <v-row justify="center">
        <v-progress-circular indeterminate size="120"></v-progress-circular>
      </v-row>
    </v-overlay>
    <v-form ref="form" v-model="valid">
      <v-layout>
        <v-flex>
          <v-card class="rounded-card pa-4" :color="colorman()" style="width: 100%">
            <v-card-title class="pb-0">
              <v-row justify="start" no-gutters>
                <v-icon large class="pr-2">mdi-clock-plus-outline </v-icon>
                <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("postWorktime") }}</h3>

                <v-spacer></v-spacer>
                <v-btn color="primary" rounded @click="refreshEntrys">{{ $t("resetInputs") }}</v-btn>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row cols="12" class="pt-8">
                <v-row justify="center">
                  <!-- Pick Employee -->
                  <v-col cols="12" v-if="employeeShow">
                    <v-row justify="center" class="px-9 py-4">
                      <v-col cols="2" class="py-4">
                        <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("employees") }}</h3>
                      </v-col>
                      <v-autocomplete
                        v-model="selectedEmployee"
                        :items="employees"
                        style="border-radius: 2em / 5em"
                        dense
                        item-text="name"
                        item-value="SAPEmpID"
                        color="primary"
                        width="auto"
                        locale="de-de"
                        required
                        solo
                        hide-details
                        rounded
                        outlined
                        autocomplete="off"
                        return-object
                      ></v-autocomplete>
                    </v-row>
                  </v-col>

                  <!-- Pick Date -->
                  <v-col cols="12">
                    <v-row justify="center" class="px-9 py-2">
                      <v-col cols="2" class="py-4">
                        <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("date") }}</h3>
                      </v-col>
                      <mydatepicker
                        v-model="date"
                        :min="minDate"
                        :max="maxDate"
                        :allowedDates="allowedDates"
                        dense
                        :notcurentdate="false"
                        :userId="userIdForDatePicker"
                        @next="setMaxAndMinTime()"
                        @monthChanged="setAbsences"
                      >
                      </mydatepicker>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <!-- Starttime -->
                      <v-col cols="6">
                        <v-row class="pl-12 py-2">
                          <v-col cols="4" justify="center" class="py-4">
                            <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("startTime") }}</h3>
                          </v-col>
                          <v-text-field
                            v-model="startTime.Time"
                            @click="startTime.TimeDialog = true"
                            style="border-radius: 2em / 5em"
                            dense
                            readonly
                            solo
                            outlined
                            hide-details
                            rounded
                          >
                          </v-text-field>
                          <v-dialog v-model="startTime.TimeDialog" persistent max-width="350" @click:outside="startTime.TimeDialog = false">
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ $t("selectTime") }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-time-picker
                                  format="24hr"
                                  color="primary"
                                  scrollable
                                  v-model="startTime.Time"
                                  :min="startTime.min"
                                  :max="startTime.max"
                                  :rules="startTime.rules"
                                  :disabled="startTime.disabled"
                                ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn text @click="startTime.TimeDialog = false">{{ $t("close") }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-col>
                      <!-- Endtime -->
                      <v-col cols="6">
                        <v-row class="pr-12 py-2">
                          <v-col cols="4" class="d-flex flex-row-reverse py-4">
                            <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("endTime") }}</h3>
                          </v-col>
                          <v-text-field
                            v-model="endTime.Time"
                            @click="endTime.TimeDialog = true"
                            style="border-radius: 2em / 5em"
                            dense
                            readonly
                            solo
                            outlined
                            hide-details
                            rounded
                          >
                          </v-text-field>
                          <v-dialog v-model="endTime.TimeDialog" persistent max-width="350" @click:outside="endTime.TimeDialog = false">
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ $t("selectTime") }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-time-picker
                                  format="24hr"
                                  color="primary"
                                  scrollable
                                  v-model="endTime.Time"
                                  :min="endTime.min"
                                  :max="endTime.max"
                                  :rules="endTime.rules"
                                  :disabled="endTime.disabled"
                                ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn text @click="endTime.TimeDialog = false">{{ $t("close") }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" v-if="workTime != '00:00'">
                    <v-row justify="center">
                      <div class="body-1" :style="{ color: $vuetify.theme.dark ? 'white' : '#B31616' }">{{ $t("sumWorkTime") }} : {{ workTime }}</div>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="pt-8">
                    <v-row v-for="(p, index) in pause" :key="p.id" cols="12">
                      <!-- Pause Start -->
                      <v-col cols="6">
                        <v-row class="pl-12 py-4">
                          <v-col cols="4" justify="center ">
                            <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("pauseStart") }}</h3>
                          </v-col>
                          <v-text-field
                            v-model="p.pauseStart.Time"
                            @click="p.pauseStart.TimeDialog = true"
                            style="border-radius: 2em / 5em"
                            dense
                            readonly
                            solo
                            outlined
                            hide-details
                            rounded
                          >
                          </v-text-field>
                          <v-dialog
                            v-model="p.pauseStart.TimeDialog"
                            persistent
                            max-width="350"
                            @click:outside="(p.pauseStart.TimeDialog = false), setPauseStart(index)"
                          >
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ $t("selectTime") }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-time-picker
                                  format="24hr"
                                  color="primary"
                                  scrollable
                                  v-model="p.pauseStart.Time"
                                  :rules="p.pauseStart.rules"
                                  :disabled="p.pauseStart.disabled"
                                  :min="p.pauseStart.min"
                                  :max="p.pauseStart.max"
                                  @change="setPauseStart(index)"
                                ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn text @click="(p.pauseStart.TimeDialog = false), setPauseStart(index)">{{ $t("close") }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-col>

                      <!-- PauseEnd -->
                      <v-col cols="6">
                        <v-row class="pr-12 py-2">
                          <v-col cols="4" class="d-flex flex-row-reverse py-4">
                            <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("pauseEnd") }}</h3>
                          </v-col>
                          <v-text-field
                            v-model="p.pauseEnd.Time"
                            @click="p.pauseEnd.TimeDialog = true"
                            style="border-radius: 2em / 5em"
                            dense
                            readonly
                            solo
                            outlined
                            hide-details
                            rounded
                          >
                          </v-text-field>
                          <v-dialog v-model="p.pauseEnd.TimeDialog" persistent max-width="350" @click:outside="p.pauseEnd.TimeDialog = false">
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ $t("selectTime") }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-time-picker
                                  format="24hr"
                                  color="primary"
                                  scrollable
                                  v-model="p.pauseEnd.Time"
                                  :rules="p.pauseEnd.rules"
                                  :disabled="p.pauseEnd.disabled"
                                  :min="p.pauseEnd.min"
                                  :max="p.pauseEnd.max"
                                  @change="setPauseEnd(index)"
                                ></v-time-picker>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn text @click="p.pauseEnd.TimeDialog = false">{{ $t("close") }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-row>
                      </v-col>

                      <v-row justify="center">
                        <div
                          v-if="pauseTimeSum != null && pauseTimeSum != '00:00'"
                          class="body-1"
                          :style="{ color: $vuetify.theme.dark ? 'white' : '#B31616' }"
                        >
                          {{ $t("sumPause") }} : {{ pauseTimeSum }}
                        </div>
                      </v-row>
                    </v-row>
                  </v-col>

                  <div align="center" class="divider"></div>

                  <!-- ServiceCalls -->
                  <v-col cols="6" class="pa-0">
                    <div v-if="$store.getters['server/serviceCallsAllowed'] == 1 && canAccessProjectBooking">
                      <v-col class="px-0">
                        <v-row no-gutters justify="center" class="pl-12 py-2">
                          <v-col cols="4" class="py-2">
                            <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("serviceCallCustomer") }}</h3>
                          </v-col>
                          <v-col>
                            <v-autocomplete
                              v-model="selectedCustomer"
                              :items="customers"
                              :item-text="setText"
                              style="border-radius: 2em / 5em"
                              dense
                              item-value="SAPEmpID"
                              color="primary"
                              width="auto"
                              :disabled="customersDisabled"
                              locale="de-de"
                              required
                              solo
                              hide-details
                              rounded
                              outlined
                              autocomplete="off"
                              return-object
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col class="px-0">
                        <v-row no-gutters justify="center" class="pl-12 py-2">
                          <v-col cols="4" class="py-2">
                            <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("serviceCall") }}</h3>
                          </v-col>
                          <v-col>
                            <v-autocomplete
                              v-model="selectedServiceCall"
                              :items="serviceCalls"
                              item-text="Subject"
                              style="border-radius: 2em / 5em"
                              dense
                              item-value="ServiceCallID"
                              :rules="serviceCallRules"
                              color="primary"
                              :disabled="serviceCallDisabled"
                              locale="de-de"
                              required
                              solo
                              hide-details
                              rounded
                              outlined
                              autocomplete="off"
                              return-object
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col class="px-0">
                        <v-row no-gutters justify="center" class="pl-12 py-2">
                          <v-col cols="4" class="py-2">
                            <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("activityType") }}</h3>
                          </v-col>
                          <v-col>
                            <v-autocomplete
                              ref="activitytypesDataVref"
                              color="primary"
                              v-model="selectedActivity"
                              :items="activityTypes"
                              item-text="ActivityType"
                              item-value="ActivityID"
                              :rules="activityRules"
                              style="border-radius: 2em / 5em"
                              dense
                              :disabled="activityTypeDisabled"
                              locale="de-de"
                              required
                              solo
                              hide-details
                              rounded
                              outlined
                              autocomplete="off"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>
                    </div>
                  </v-col>

                  <!-- Projects -->
                  <v-col cols="6" class="pa-0">
                    <div v-if="$store.getters['server/stageProjectsAllowed'] == 1 && canAccessProjectBooking">
                      <v-col class="px-0">
                        <v-row no-gutters justify="center" class="pr-12 py-2">
                          <v-col cols="4" class="d-flex flex-row-reverse pr-2 py-2">
                            <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("project") }}</h3>
                          </v-col>
                          <v-autocomplete
                            color="primary"
                            v-model="selectedStageProject"
                            style="border-radius: 2em / 5em"
                            dense
                            :item-text="$store.getters['server/showFinanceProjectByProjectManagement'] ? 'FinancialProject' : 'ProjectName'"
                            :items="stageProjects"
                            :disabled="stageProjectsDisabled"
                            required
                            autocomplete="off"
                            solo
                            hide-details
                            rounded
                            outlined
                            return-object
                          ></v-autocomplete>
                        </v-row>
                      </v-col>

                      <v-col class="px-0">
                        <v-row no-gutters justify="center" class="pr-12 py-2" v-if="$store.getters['server/stageProjectsAllowed'] == 1">
                          <v-col cols="4" class="d-flex flex-row-reverse pr-2 py-2">
                            <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("stage") }}</h3>
                          </v-col>
                          <v-autocomplete
                            color="primary"
                            v-model="selectedStage"
                            item-text="Description"
                            style="border-radius: 2em / 5em"
                            dense
                            item-value="StageID"
                            :items="stages"
                            :rules="stageRules"
                            :disabled="stageDisabled"
                            required
                            autocomplete="off"
                            solo
                            hide-details
                            rounded
                            outlined
                            return-object
                          ></v-autocomplete>
                        </v-row>
                      </v-col>
                    </div>

                    <v-col class="px-0">
                      <v-row no-gutters justify="center" class="pr-12 py-2" v-if="$store.getters['server/showCostCentre'] == 1">
                        <v-col cols="4" class="d-flex flex-row-reverse pr-2 py-2">
                          <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("costCentre") }}</h3>
                        </v-col>
                        <v-autocomplete
                          color="primary"
                          v-model="selectedProfitCenter"
                          item-text="CenterName"
                          style="border-radius: 2em / 5em"
                          dense
                          item-value="CenterCode"
                          :items="profitCenters"
                          :disabled="profitCenterDisabled"
                          required
                          autocomplete="off"
                          solo
                          hide-details
                          rounded
                          outlined
                          return-object
                        ></v-autocomplete>
                      </v-row>
                    </v-col>

                    <v-col class="px-0">
                      <v-row no-gutters justify="center" class="pr-12 py-2" v-if="$store.getters['server/financeProjectsAllowed'] == 1">
                        <v-col cols="4" class="d-flex flex-row-reverse pr-2 py-2">
                          <h3 justfiy="center" :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("financeProjects") }}</h3>
                        </v-col>
                        <v-autocomplete
                          color="primary"
                          v-model="selectedProject"
                          item-text="Name"
                          style="border-radius: 2em / 5em"
                          dense
                          item-value="Code"
                          :items="projects"
                          :disabled="projectDisabled"
                          required
                          autocomplete="off"
                          solo
                          hide-details
                          rounded
                          outlined
                        ></v-autocomplete>
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>

                <div v-if="canAccessProjectBooking" style="width: 100%; display: flex; padding-top: 2rem">
                  <div style="margin: auto" class="divider"></div>
                </div>

                <!-- Non-Billable Time -->
                <v-row cols="12" class="d-flex">
                  <v-spacer></v-spacer>
                  <v-col cols="6" class="pr-12 py-8">
                    <v-row align="center">
                      <v-col class="pl-0 d-flex flex-row-reverse" cols="4">
                        <h3 :class="$vuetify.theme.dark ? 'dark' : 'light'">{{ $t("nonBillableTime") }}</h3>
                      </v-col>
                      <v-col class="px-0">
                        <v-text-field
                          v-model="NonBillableTime.Time"
                          @click="NonBillableTime.TimeDialog = true"
                          style="border-radius: 2em / 5em"
                          dense
                          readonly
                          outlined
                          solo
                          hide-details
                          rounded
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-dialog v-model="NonBillableTime.TimeDialog" persistent max-width="350" @click:outside="NonBillableTime.TimeDialog = false">
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ $t("hours") }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-time-picker format="24hr" color="primary" scrollable v-model="NonBillableTime.Time"></v-time-picker>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="NonBillableTime.TimeDialog = false">{{ $t("close") }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row justify="end" class="pa-2" no-gutters>
                <!-- <v-btn color="primary" rounded class="mr-4 pa-7" @click="refreshEntrys()">{{ $t("delete") }}</v-btn> -->
                <v-btn color="primary" rounded class="ml-4 pa-7" @click="send">{{ $t("send") }}</v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <ProjectText
      v-if="ShowProjectComment && $store.getters['server/allowProjectText']"
      @saveComment="
        projectComment = $event;
        ShowProjectComment = false;
      "
      @close="ShowProjectComment = false"
    />
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import "moment-duration-format";

if (!Number.prototype.mod) {
  Number.prototype.mod = function (n) {
    return ((this % n) + n) % n;
  };
}

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    return this[index.mod(this.length)];
  };
}

export default {
  name: "ManualTimekeeping",
  route: "ManualTimekeeping",
  components: {
    ProjectText: () => import("../components/DefaultClient/ProjectText.vue")
  },
  data: () => ({
    windowWidth: $(window).width(),

    employees: [],
    selectedEmployee: null,
    employeeShow: false,

    date: moment().format("YYYY-MM-DD"),
    minDate: null,
    maxDate: moment().format("YYYY-MM-DD"),

    NonBillableTime: {
      Time: null,
      TimeDialog: false,
      min: null,
      max: null,
      disabled: false
    },
    startTime: {
      Time: null,
      TimeDialog: false,
      min: null,
      max: null,
      disabled: false,
      rules: [(v) => !!v || "Time is required"]
    },
    endTime: {
      Time: null,
      TimeDialog: false,
      min: null,
      max: null,
      disabled: true,
      rules: [(v) => !!v || "Time is required"]
    },

    workTime: "00:00",

    btnAddPuseDis: true, // TODO: hinzufügt eine neue Pause
    btnRemovePuseDis: true, //

    pause: [
      {
        id: 1,
        pauseStart: {
          Time: null,
          TimeDialog: false,
          min: null,
          max: null,
          disabled: true,
          rules: []
        },
        pauseEnd: {
          Time: null,
          TimeDialog: false,
          min: null,
          max: null,
          disabled: true,
          rules: []
        },
        pauseTimeSum: null
      }
    ],

    customers: [""],
    selectedCustomer: [""],
    customersDisabled: false,

    profitCenters: [""],
    selectedProfitCenter: null,
    profitCenterDisabled: false,

    stageProjects: [],
    selectedStageProject: null,
    stageProjectsDisabled: false,

    projects: [""],
    selectedProject: null,
    projectDisabled: false,

    serviceCalls: [""],
    selectedServiceCall: null,
    serviceCallDisabled: true,
    serviceCallRules: [],

    stages: [""],
    selectedStage: null,
    stageDisabled: true,
    stageRules: [],

    activityTypes: [""],
    selectedActivity: null,
    activityTypeDisabled: true,
    activityRules: [],

    pauseTimeSum: null,
    Arbeitzeit: "",

    loaderOverlay: false,
    absenceDate: [],

    valid: true,

    processing: false,

    userIdForDatePicker: null,

    ShowProjectComment: false,
    projectComment: null,

    timeAccount: null
  }),
  computed: {
    ...mapGetters({
      User: "user/user",
      absences: "absences/absences"
    }),
    canAccessProjectBooking() {
      return (
        (this.$store.getters["server/stageProjectsAllowed"] == 1 || this.$store.getters["server/serviceCallsAllowed"] == 1) &&
        this.$store.getters["user/user"].userGroupRights.canAccessProjects
      );
    },
    items: function () {
      return [
        {
          name: "ServiceCallCustomer",
          value: "",
          itemText: "CustomerCode",
          items: [],
          label: $t("serviceCallCustomer"),
          disabled: false,
          rules: []
        },
        {
          name: "Project",
          value: "",
          itemText: "ProjectName",
          items: [],
          label: $t("project"),
          disabled: false,
          rules: []
        },
        {
          name: "ServiceCall",
          value: "",
          itemText: "Subject",
          itemValue: "ServiceCallID",
          items: [],
          label: $t("serviceCall"),
          disabled: false,
          rules: serviceCallRules
        },
        {
          name: "Stage",
          value: "",
          itemText: "Description",
          itemValue: "StageID",
          items: [],
          label: $t("stage"),
          disabled: false,
          rules: serviceCallRules
        },
        {
          name: "Aktive",
          value: "",
          itemText: "ActivityType",
          itemValue: "ActivityID",
          items: [],
          label: $t("activityType"),
          disabled: false,
          rules: serviceCallRules
        }
      ];
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    refocusHours(n = 0) {
      try {
        const btns = Array.prototype.slice.call(document.getElementsByClassName("v-picker__title__btn"));

        if (btns.length > 0) btns.at(-2 * n)?.click();
      } catch {}
    },
    sortFunction(a, b, property = null) {
      return property ? a[property].localeCompare(b[property]) : a.localeCompare(b);
    },
    async initialize() {
      this.loaderOverlay = true;
      await this.getStatus();
      await this.getSettings();

      let userId = this.employeeShow ? this.selectedEmployee.SAPEmpID : this.User.SAPEmpId;
      this.userIdForDatePicker = userId;

      let serviceCallOn = this.$store.getters["server/serviceCallsAllowed"] == 1 ? true : false;
      let stageProjectsOn = this.$store.getters["server/stageProjectsAllowed"] == 1 ? true : false;
      let financeProjektOn = this.$store.getters["server/financeProjectsAllowed"] == 1 ? true : false;

      if (financeProjektOn) await this.getProjects();
      if (stageProjectsOn) await this.getProjectsForUser(userId);
      if (serviceCallOn) await this.getServiceTypePermissions(userId);
      if (stageProjectsOn || stageProjectsOn) await this.getProjectManagementActivityTypes();

      await this.getProfitCenters();

      this.setMaxAndMinTime();

      if (this.User.userGroupRights.canManipulateBookingLines) {
        await this.getTeamsUsers();
      }

      this.minDate = this.selectedEmployee?.weekModel?.U_validFrom;

      // Set rules for startTime
      this.startTime.rules = [(v) => !!v || this.$t("timeIsRequired")];

      this.loaderOverlay = false;
    },
    async getStatus() {
      await this.$store
        .dispatch("user/getStatus", {
          timeStamp: this.$moment(),
          executeImmediately: false
        })
        .then(() => {
          if (!this.$store.getters["user/user"].userGroupRights.canAccessManualTimeManagement) this.$router.push("Login");
        })
        .catch((err) => {
          //this.loaderOverlay = false;
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    async getProjects() {
      await this.$store
        .dispatch("user/getProjects", this.User.SAPEmpId)
        .then((res) => {
          this.projects = res.data.sort((a, b) => this.sortFunction(a, b, "Name"));
          this.projects.unshift("");
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    getProjectsForUser(userId) {
      this.$store
        .dispatch("user/getProjectsForUser", userId)
        .then((res) => {
          this.stageProjects = res.data.sort((a, b) => this.sortFunction(a, b, "ProjectName"));
          this.stageProjects.unshift("");
        })
        .catch((err) => {
          if (err.status != 200) {
            this.$eventHub.$emit("showError", err.data, "bottom", "right");
          }
        });
    },
    async getServiceTypePermissions(userId) {
      await this.$store
        .dispatch("user/getServiceTypePermissionForUserWithPermission", userId)
        .then((res) => {
          if (process.env.NODE_ENV == "development") {
            console.log("call user/getServiceTypePermissionForUser");
          }
          this.customers = res.data.sort((a, b) => this.sortFunction(a, b, "CustomerCode"));
          this.customers.unshift("");
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getProfitCenters() {
      await this.$store
        .dispatch("user/getProfitCenters", this.User.SAPEmpId)
        .then((res) => {
          this.profitCenters = res.data.sort((a, b) => this.sortFunction(a, b, "CenterName"));
          this.profitCenters.unshift("");
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    getProjectManagementActivityTypes() {
      this.$store
        .dispatch("user/getProjectManagementActivityTypes")
        .then((res) => {
          this.activityTypes = res.data.sort((a, b) => this.sortFunction(a, b, "ActivityType"));
        })
        .catch((err) => {
          if (err.status != 200) {
            this.$eventHub.$emit("showError", err.data, "bottom", "right");
          }
        });
    },
    setMaxAndMinTime() {
      var currentDate = Helper.setCurrentDateYearMonthDayAsString();
      currentDate = moment().format("YYYY-MM-DD");

      if (moment(this.date).isSame(moment(currentDate))) {
        this.endTime.max = moment().format("HH:mm");
        this.startTime.max = moment().format("HH:mm");

        if (this.endTime.Time > moment().format("HH:mm")) {
          this.endTime.Time = moment().format("HH:mm");
        }
        if (this.startTime.Time > moment().format("HH:mm")) {
          this.startTime.Time = moment().format("HH:mm");
        }
      } else {
        this.endTime.max = "23:59";
        this.startTime.max = "23:59";
      }
    },
    async getTeamsUsers() {
      await this.$store
        .dispatch("users/getEmployees", this.User.SAPEmpId)
        .then((res) => {
          this.employees = res.data;
          for (let employee of this.employees) {
            if (employee.SAPEmpID == this.User.SAPEmpId) this.selectedEmployee = employee;
          }
          if (this.employees.length != 0) this.employeeShow = true;
        })
        .catch((err) => {
          this.showLoaderOverlay(false);
          if (err.response.status != 200) {
            this.showMessage(err.response.data);
          }
        });
    },
    setStartTime() {
      if (this.startTime.Time !== null) {
        this.pause[0].pauseStart.disabled = false;
        this.pause[0].pauseStart.min = this.startTime.Time;
        this.endTime.disabled = false;
        this.endTime.min = this.startTime.Time;
        if (this.endTime.min > this.endTime.Time) this.endTime.Time = this.endTime.min;
        this.endTime.rules = [(v) => !!v || this.$t("timeIsRequired")];
        this.btnRemovePuseDis = false;
        this.SumAllPause();
      }
    },
    setEndTime() {
      if (this.endTime.Time !== "") {
        var curId = this.pause.length;
        if (this.pause[curId - 1].pauseEnd.disabled == false) {
          this.pause[curId - 1].pauseEnd.max = this.endTime.Time;
          if (Helper.convTime2Minit(this.pause[curId - 1].pauseEnd.Time) <= 0) this.pause[curId - 1].pauseStart.max = this.endTime.Time;
        } else if (this.pause[curId - 1].pauseStart.disabled == false) {
          this.pause[curId - 1].pauseStart.max = this.endTime.Time;
        }
        this.SumAllPause();
      }
    },
    setPauseStart(index) {
      if (index == 0) {
        this.startTime.max = this.pause[index].pauseStart.Time;
      } else {
        this.pause[index - 1].pauseEnd.max = this.pause[index].pauseStart.Time;
      }
      this.pause[index].pauseEnd.disabled = false;
      this.pause[index].pauseEnd.min = this.pause[index].pauseStart.Time;
      this.pause[index].pauseEnd.max = this.endTime.Time;
      this.pause[index].pauseEnd.rules = [(v) => !!v || this.$t("timeIsRequired")];

      if (Helper.convTime2Minit(this.pause[index].pauseEnd.Time) > 0) {
        this.pause[index].pauseTimeSum = Helper.difBtwTimes(this.pause[index].pauseStart.Time, this.pause[index].pauseEnd.Time);
        this.SumAllPause();
        this.sumWorkTime();
      }
    },
    setPauseEnd(index) {
      var curId = this.pause.length;
      if (curId == index + 1) {
        this.endTime.min = this.pause[index].pauseEnd.Time;
        this.btnAddPuseDis = false;
      } else {
        this.pause[index + 1].pauseStart.min = this.pause[index].pauseEnd.Time;
      }
      this.pause[index].pauseStart.max = this.pause[index].pauseEnd.Time;
      this.pause[index].pauseTimeSum = Helper.difBtwTimes(this.pause[index].pauseStart.Time, this.pause[index].pauseEnd.Time);
      this.SumAllPause();
      this.sumWorkTime();
    },
    addPause() {
      var curId = this.pause.length;
      this.pause.push({
        id: curId + 1,
        pauseStart: {
          Time: "",
          TimeDialog: false,
          min: this.pause[curId - 1].pauseEnd.Time,
          max: this.endTime.Time,
          disabled: false
        },
        pauseEnd: {
          Time: "",
          TimeDialog: false,
          min: "",
          max: this.endTime.Time,
          disabled: true
        },
        pauseTimeSum: ""
      });
      this.btnAddPuseDis = true;
    },
    removePause() {
      var curId = this.pause.length;
      if (curId == 1) {
        this.pause[0].pauseStart.Time = "";
        this.pause[0].pauseEnd.Time = "";
        this.pause[0].pauseEnd.disabled = true;
        this.pause[0].pauseStart.disabled = false;
        this.pause[0].pauseStart.min = this.startTime.Time;
        this.pause[0].pauseStart.max = this.endTime.Time;
        this.pause[0].pauseEnd.max = "";
        this.pause[0].pauseEnd.max = "";
        this.pause[0].pauseTimeSum = "";

        this.endTime.min = this.startTime.Time;
        this.btnAddPuseDis = true;
      } else {
        this.pause.splice(curId - 1, 1);
        this.endTime.min = this.pause[curId - 2].pauseEnd.Time;
        this.btnAddPuseDis = false;
        this.pause[curId - 2].pauseEnd.max = this.endTime.Time;
      }
      this.SumAllPause();
    },
    SumAllPause() {
      var curId = this.pause.length;
      var allMinitPause = 0;
      for (let i = 0; i < curId; i++) {
        allMinitPause += Helper.convTime2Minit(this.pause[i].pauseTimeSum);
      }
      this.pauseTimeSum = Helper.convMinit2Time(allMinitPause);
      var minitStartTime = Helper.convTime2Minit(this.startTime.Time);
      var minitEndTime = Helper.convTime2Minit(this.endTime.Time);
      if (minitEndTime > 0) {
        this.Arbeitzeit = Helper.convMinit2Time(minitEndTime - minitStartTime - allMinitPause);
      }
    },
    sumWorkTime() {
      if (this.endTime.Time != null && this.startTime.Time != null) {
        let diff = moment(this.endTime.Time, "HH:mm").diff(moment(this.startTime.Time, "HH:mm"));

        if (this.NonBillableTime.Time != null) {
          let workTimeSum = moment.utc(diff).format("HH:mm");

          diff = moment(workTimeSum, "HH:mm").diff(moment(this.NonBillableTime.Time, "HH:mm"));
        }

        if (this.pauseTimeSum != null) {
          let pauseMillis = moment(this.pauseTimeSum, "HH:mm").format("x");

          let workTimeSum = moment.utc(diff).format("HH:mm");

          workTimeSum = moment(workTimeSum, "HH:mm").diff(moment(this.pauseTimeSum, "HH:mm"));

          this.workTime = moment.utc(workTimeSum).format("HH:mm");
        } else this.workTime = moment.utc(diff).format("HH:mm");
      } else this.workTime = "00:00";
    },
    colorman() {
      if (this.$vuetify.theme.dark) return "grey darken-4";
      else return "grey lighten-3";
    },
    async send() {
      if (this.processing) return;
      this.processing = true;
      if (this.$refs.form.validate() && this.startTime.Time && this.endTime.Time) {
        let user = {
          id: this.employeeShow ? this.selectedEmployee.SAPEmpID : this.User.SAPEmpId,
          teams: this.employeeShow ? this.selectedEmployee.teams : this.User.Teams,
          timeAccount: this.employeeShow ? this.selectedEmployee.weekModel : this.timeAccount
        };
        let timeSheetLine = {
          userId: user.id,
          date: this.date,
          startTime: this.startTime.Time,
          endTime: this.endTime.Time,
          pauseStart: this.pause[0].pauseStart.Time,
          pauseEnd: this.pause[0].pauseEnd.Time,
          nonBillableTime: this.NonBillableTime.Time,
          project: this.setProject(),
          financeProject: this.selectedProject,
          activityType: this.selectedActivity,
          costCenter: this.selectedProfitCenter?.CenterCode,
          serviceCall: this.selectedServiceCall?.ServiceCallID ?? null,
          projectComment: this.projectComment
        };
        this.loaderOverlay = true;
        if (this.checkConflicts(user)) await this.sendTimeSheetLine(timeSheetLine);
        this.loaderOverlay = false;
      } else {
        this.processing = false;
      }
    },
    setProject() {
      return {
        projectCode: this.selectedStageProject?.FinancialProject ?? null,
        stageId: this.selectedStage?.StageID ?? null,
        projectId: this.selectedStageProject?.AbsEntry ?? null
      };
    },
    checkConflicts(user) {
      let workTime = this.workTimeSum(this.startTime.Time, this.endTime.Time);

      if (this.startTime.Time.length === 0) {
        this.showMessage(this.$t("startTimeMissin"));
        return false;
      } else if (this.endTime.Time.length === 0) {
        this.showMessage(this.$t("endTimeMissing"));
        return false;
      } else if (moment(this.startTime.Time, "HH:mm").isSameOrAfter(moment(this.endTime.Time, "HH:mm"))) {
        this.showMessage(this.$t("endTimeBeforeStart"));
        return false;
      } else if (moment(this.pause[0].pauseStart.Time, "HH:mm").isSameOrAfter(moment(this.pause[0].pauseEnd.Time, "HH:mm"))) {
        this.showMessage(this.$t("pauseEndBeforeStart"));
        return false;
      } else if (moment(this.NonBillableTime.Time, "HH:mm").isSameOrAfter(moment(workTime, "HH:mm"))) {
        this.showMessage(this.$t("effectiveTimeError"));
        return false;
      } else if (!user.timeAccount) {
        this.showMessage(this.$t("notTimeAccountForUserError"));
        return false;
      } else if (user.timeAccount.U_validFrom > this.date) {
        this.showMessage(this.$t("dateOutOfTimeAccountRange"));
        return false;
      } else if (!this.selectedStage && this.selectedStageProject && this.selectedStageProject !== "") {
        this.showMessage(this.$t("ProjectStageNotSelected"));
        return false;
      }
      return true;
    },
    workTimeSum(start, end) {
      let millis = moment(end, "HH:mm").diff(moment(start, "HH:mm"));
      console.log(millis);
      return moment.duration(millis).format("HH:mm", { trim: false });
    },
    async sendTimeSheetLine(timeSheetLine) {
      console.log("HFF");
      await this.$store
        .dispatch("simpleClient/sendTimeSheetLine", timeSheetLine)
        .then((res) => {
          this.$eventHub.$emit("showSuccess", this.$t("successfullyTransmitted") + "!");
          this.loaderOverlay = false;
        })
        .catch((err) => {
          if (err.response.status != 200) {
            this.showMessage(this.$t(`${err.response.data}`));
            this.loaderOverlay = false;
          }
        });
      this.processing = false;
    },
    refreshEntrys() {
      this.$refs.form.resetValidation();
      this.NonBillableTime = {
        Time: null,
        TimeDialog: false,
        min: null,
        max: null,
        disabled: false
      };

      this.startTime = {
        Time: null,
        TimeDialog: false,
        min: null,
        max: null,
        disabled: false,
        rules: [(v) => !!v || this.$t("timeIsRequired")]
      };

      this.endTime = {
        Time: null,
        TimeDialog: false,
        min: null,
        max: null,
        disabled: true,
        rules: []
      };

      this.workTime = "00:00";

      this.pause = [
        {
          id: 1,
          pauseStart: {
            Time: null,
            TimeDialog: false,
            min: null,
            max: null,
            disabled: true
          },
          pauseEnd: {
            Time: null,
            TimeDialog: false,
            min: null,
            max: null,
            disabled: true
          },
          pauseTimeSum: null
        }
      ];

      this.selectedActivity = null;
      this.selectedProject = null;
      this.selectedProfitCenter = null;
      this.selectedServiceCall = null;
      this.activityTypeDisabled = true;
      this.projectDisabled = false;
      this.profitCenterDisabled = false;
      this.selectedStageProject = null;
      this.selectedStage = null;
      this.selectedCustomer = null;
      this.refreshPauseStartTimePicker++;
      this.setMaxAndMinTime();
    },
    allowedDates(val) {
      let dates = [];
      for (let absence of this.absenceDate) {
        if (absence.type == "holiday") continue;
        if (absence.type == "work") continue;
        dates.push(absence.date);
      }
      if (dates.includes(val)) {
        return false;
      } else {
        return true;
      }
    },
    showMessage(message) {
      this.$eventHub.$emit("showError", message, "bottom", "right");
    },
    setAbsences(absences) {
      this.absenceDate = absences;
    },
    async getSettings() {
      await this.$store
        .dispatch("server/getSettings", this.$moment())
        .then(() => {})
        .catch((err) => {
          this.$eventHub.$emit("showError", err.response.data.error, "bottom", "right");
        });
    },
    setText(val) {
      return val.CustomerCode + " - " + val.CustomerName;
    }
  },
  watch: {
    startTime: {
      handler(val) {
        this.refocusHours();
      },
      deep: true
    },
    endTime: {
      handler(val) {
        this.refocusHours(1);
      },
      deep: true
    },
    pause: {
      handler([val]) {
        this.refocusHours(2);
      },
      deep: true
    },
    dialogPin: function (val) {
      this.dialogPin = val;
      if (this.dialogPin) {
        this.$nextTick(() => this.$refs.ppass.focus());
      }
    },
    windowWidth() {},
    "startTime.Time"() {
      this.setStartTime();
      if (this.endTime.Time != null) this.sumWorkTime();
    },
    "endTime.Time"() {
      this.setEndTime();
      this.sumWorkTime();
    },
    selectedProfitCenter() {
      if (this.selectedProfitCenter != "" && this.selectedProfitCenter != null) {
        this.customersDisabled = true;
        this.selectedCustomer = null;
        this.selectedServiceCall = null;
      } else {
        this.customersDisabled = false;
      }
    },
    selectedCustomer() {
      if (this.selectedCustomer != "" && this.selectedCustomer != null) {
        this.serviceCalls = this.selectedCustomer.ServiceCalls.sort((a, b) => this.sortFunction(a, b, "Subject"));
        this.profitCenterDisabled = true;
        this.projectDisabled = true;
        this.stageProjectsDisabled = true;
        this.serviceCallDisabled = false;
        this.serviceCallRules = [(v) => !!v || this.$t("serviceCallIsRequired")];
      } else {
        this.profitCenterDisabled = false;
        this.projectDisabled = false;
        this.stageProjectsDisabled = false;
        this.selectedServiceCall = null;
        this.serviceCallDisabled = true;
        this.serviceCallRules = [];
      }
      if (this.selectedCustomer == null && this.selectedProject != "" && this.selectedProject != null) {
        this.projectDisabled = true;
      }
    },
    selectedServiceCall() {
      if (this.selectedServiceCall != null && this.selectedServiceCall != "") {
        this.ShowProjectComment = true;
        if (this.selectedServiceCall.Activities.length != 0) {
          this.activityTypes = this.selectedServiceCall.Activities.sort((a, b) => this.sortFunction(a, b, "ActivityType"));
          this.activityTypeDisabled = false;
          this.activityRules = [(v) => !!v || this.$t("activityIsRequired")];
        } else {
          this.activityTypes = [];
          this.activityTypeDisabled = true;
          this.selectedActivity = null;
          this.activityRules = [];
        }
      } else {
        this.activityTypes = [];
        this.activityRules = [];
        this.selectedActivity = null;
        this.activityTypeDisabled = true;
      }
    },
    selectedProject() {
      if (this.selectedProject != "" && this.selectedProject != null) {
        this.customersDisabled = true;
        this.selectedCustomer = null;
        this.selectedServiceCall = null;
        this.ShowProjectComment = true;
      } else {
        this.customersDisabled = false;
      }
    },
    selectedStageProject(project) {
      if (project != "" && project != null) {
        this.stageDisabled = false;
        this.customersDisabled = true;
        this.selectedCustomer = null;
        this.selectedServiceCall = null;
        this.stages = project.Stages.sort((a, b) => this.sortFunction(a, b, "Description"));
        this.stageRules = [(v) => !!v || this.$t("stageIsRequired")];
        this.ShowProjectComment = true;
        this.selectedProject = project.FinancialProject;
        this.projectDisabled = true;
      } else {
        this.stageDisabled = true;
        this.customersDisabled = false;
        this.stageRules = [];
        this.projectDisabled = false;
        this.selectedProject = null;
        this.selectedStage = null;
      }
    },
    selectedStage() {
      if (this.selectedStage != "" && this.selectedStage != null) {
        this.activityTypes = this.selectedStage.Activities.sort((a, b) => this.sortFunction(a, b, "ActivityType"));
        this.activityTypeDisabled = false;
        if (this.activityTypes.length != 0) this.activityRules = [(v) => !!v || this.$t("activityIsRequired")];
        else this.activityRules = [];
      } else {
        this.activityTypes = [];
        this.selectedActivity = null;
        this.activityTypeDisabled = true;
        this.activityRules = [];
      }
    },
    async selectedEmployee(empId) {
      this.selectedStageProject = null;
      this.selectedStage = null;
      this.selectedActivity = null;
      this.userIdForDatePicker = empId.SAPEmpID;
      this.minDate = this.selectedEmployee?.weekModel?.U_validFrom;
      if (this.date < this.minDate) {
        this.date = this.minDate;
      }
    }
  }
};
//@ sourceURL=simpleClient.js
</script>

<style scoped>
.divider {
  width: 80%;
  border-top: 1px solid #464646;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

/* h3 { */
.dark {
  color: white;
}

.light {
  color: rgb(26, 26, 26);
}

/* } */
</style>
